import { getRecaptchaSiteKeyFromDOM } from "@@/utils/getTokenRecaptcha";

export async function getRecaptchaTokenSafe(action: string): Promise<string | null> {

    if (typeof window !== "undefined" && window.location.hostname === "localhost") {
        return "fake-recaptcha-token";
    }

    const siteKey = getRecaptchaSiteKeyFromDOM();
    if (!siteKey) {
        console.error("[reCAPTCHA] siteKey introuvable dans le DOM");
        return null;
    }

    const ok = await waitFor(() => !!(window as any).grecaptcha, 5000, 50);
    if (!ok) {
        console.error("[reCAPTCHA] grecaptcha introuvable après délai");
        return null;
    }

    await new Promise<void>((resolve) => {
        (window as any).grecaptcha.ready(() => resolve());
    });

    try {
        const token = await (window as any).grecaptcha.execute(siteKey, { action });
        return typeof token === "string" && token ? token : null;
    } catch (e) {
        console.error("[reCAPTCHA] execute() a échoué:", e);
        return null;
    }
}

async function waitFor(test: () => boolean, timeoutMs: number, stepMs: number) {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
        if (test()) return true;
        await new Promise(r => setTimeout(r, stepMs));
    }
    return false;
}